<template>
  <div class="indify-loader">
    <div class="waveform">
      <div
        v-for="n in 5"
        :key="n"
        class="wave-bar"
        :style="{ '--delay': `${(n - 1) * 0.15}s` }"
      />
    </div>
    <div class="loader-text">
      {{ $t('general.loading') }}
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<style lang="scss" scoped>
.indify-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  gap: 1rem;

  .waveform {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    height: 40px;
    padding: 0.5rem;

    .wave-bar {
      width: 4px;
      height: 100%;
      background: linear-gradient(180deg, var(--color-primary, #3e8ed0) 0%, var(--color-accent, #8888ff) 100%);
      border-radius: 2px;
      animation: wave 1s ease-in-out infinite;
      animation-delay: var(--delay);
      transform-origin: center;

      // Dark mode styling
      .body--dark & {
        background: linear-gradient(180deg, #4a5af8 0%, #8888ff 100%);
        box-shadow: 0 0 8px rgba(74, 90, 248, 0.4);
      }
    }
  }

  .loader-text {
    font-size: 0.9rem;
    color: var(--color-text-light);
    font-weight: 500;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    animation: pulse 2s ease-in-out infinite;

    // Dark mode text
    .body--dark & {
      color: rgba(255, 255, 255, 0.7);
    }
  }
}

@keyframes wave {
  0%, 100% {
    transform: scaleY(0.3);
    opacity: 0.3;
  }
  50% {
    transform: scaleY(1);
    opacity: 1;
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
}

// Responsive styles
@media (max-width: 768px) {
  .indify-loader {
    padding: 1.5rem;

    .waveform {
      height: 32px;
      gap: 3px;

      .wave-bar {
        width: 3px;
      }
    }

    .loader-text {
      font-size: 0.8rem;
    }
  }
}
</style>